import React, { memo, useCallback, useEffect, useState } from 'react';
import {
  Card,
  Input,
  Controller,
  Button,
  SelectBox,
} from 'components/src';
import { useTranslation } from 'react-i18next';
import { FormProvider, useForm } from 'react-hook-form';
import { Form, Switch, message } from 'antd';
import {
  useGetAdminUsersList,
  useGetAuthorityFindCategory,
  useGetAuthorityFindRoles,
  usePatchAdminUpdateUserProfileByAdmin,
} from 'core';
import { useParams } from 'react-router-dom';
import LoadingView from '../../atoms/loadingView';

const NAMEANDFAMILY = 'nameAndFamily';
const USERNAME = 'userName';
const CATEGORY = 'category';
const ADDROLE = 'addRole';
const REMOVEROLE = 'removeRole';
const MOBILENUMBER = 'mobileNumber';
const ISACTIVE = 'isActive';
const ADMINISTRATOR = 'administrator';
const SUPERVISOR = 'supervisor';
const HALLMANAGER = 'hallManager';
const SALEMANAGER = 'saleManager';
const PASSWORD = 'password';

const layout = {
  labelCol: { span: 5 },
  wrapperCol: { span: 16 },
};

const EditUser = memo(() => {
  const { i18n } = useTranslation();
  const [messageApi, contextHolder] = message.useMessage();

  const { id } = useParams();

  const { data: { data: roleData } = {}, refetch: refetchRole } =
    useGetAuthorityFindRoles({
      pageNumber: '1',
      pageSize: '2000',
    });
  const {
    data: { data } = {},
    isFetching: listFetch,
    refetch,
  } = useGetAdminUsersList({
    pageNumber: '1',
    pageSize: '1',
    userId: id,
  });

  const [status, setStatus] = useState(false);

  const allRolesItem = roleData?.roles?.map(
    (item: { name: string }) => {
      return item.name;
    }
  );
  const removeRoles = data?.users?.[0]?.role?.map((item: any) => {
    return item.name;
  });

  const addRoles = allRolesItem?.filter((item: any) => {
    return !removeRoles?.includes(item);
  });

  const addRolesItem = addRoles?.map((item: any) => {
    return {
      value: item,
      label: item,
    };
  });

  console.log(addRolesItem);

  const removeRolesItem = removeRoles?.map((item: any) => {
    return {
      value: item,
      label: item,
    };
  });

  useEffect(() => {
    setStatus(data?.users?.[0]?.isActive);
    if (data && !isPending) {
      reset({
        nameAndFamily: data?.users?.[0]?.nameAndFamily,
        userName: data?.users?.[0]?.userName,
        // role: roles,
        mobileNumber: data?.users?.[0]?.mobileNumber,
        category: data?.users?.[0]?.category?.name,
        administrator: data?.users?.[0]?.administrator?.userName,
        supervisor: data?.users?.[0]?.supervisor?.userName,
        isActive: data?.users?.[0]?.isActive,
        saleManager: data?.users?.[0]?.saleManager?.userName,
        hallManager: data?.users?.[0]?.hallManager?.userName,
      });
    }
  }, [data]);

  const methods = useForm({
    defaultValues: {
      nameAndFamily: '',
      userName: '',
      addRole: [],
      removeRole: [],
      mobileNumber: '',
      category: '',
      isActive: data?.users?.[0]?.isActive,
      administrator: '',
      supervisor: '',
      saleManager: '',
      hallManager: '',
      password: '',
    },
  });

  const { handleSubmit, reset } = methods;

  const onSubmit = useCallback(
    ({
      nameAndFamily,
      userName,
      addRole,
      removeRole,
      mobileNumber,
      category,
      administrator,
      supervisor,
      saleManager,
      hallManager,
      password,
    }: {
      nameAndFamily: string;
      userName: string;
      mobileNumber: any;
      addRole: any;
      removeRole: any;
      isActive: boolean;
      category: any;
      administrator: string;
      supervisor: string;
      hallManager: string;
      saleManager: string;
      password: string;
    }) => {
      mutate({
        requestBody: {
          mainUserName: data?.users?.[0].userName,
          nameAndFamily: nameAndFamily,
          userName: userName,
          mobileNumber: mobileNumber,
          category: category.toString(),
          addRole: addRole,
          removeRole: removeRole,
          email: '',
          isActive: status,
          administrator: administrator,
          supervisor: supervisor,
          ...(password?.length && { password: password }),
          hallManager: hallManager,
          saleManager: saleManager,
        },
      });
    },
    [data, status]
  );

  const { mutate, isPending } = usePatchAdminUpdateUserProfileByAdmin(
    {
      onSuccess: () => {
        messageApi.open({
          type: 'success',
          content: i18n.t('done'),
        });
        refetch();
      },
    }
  );

  const { data: _data } = useGetAdminUsersList({
    pageNumber: '1',
    pageSize: '3000',
  });
  const { data: categoriesData } = useGetAuthorityFindCategory({
    pageNumber: '1',
    pageSize: '1000',
  });

  const administratorsItem = _data?.data?.users?.map((item: any) => {
    return {
      value: item?.userName,
      label: item?.nameAndFamily,
    };
  });

  const categoriesItem = categoriesData?.data?.categories?.map(
    (item: any) => {
      return {
        value: item.id,
        label: item.name,
      };
    }
  );

  console.log({ categoriesItem });

  return (
    <>
      {contextHolder}

      <LoadingView isLoading={listFetch}>
        <Card title={i18n.t('EditUser')}>
          <FormProvider {...methods}>
            <Form
              {...layout}
              name="nest-messages"
              onFinish={handleSubmit(onSubmit)}
            >
              <Form.Item>
                <Controller name={NAMEANDFAMILY}>
                  <Input placeholder={i18n.t('nameAndFamily')} />
                </Controller>
              </Form.Item>

              <Form.Item>
                <Controller name={USERNAME}>
                  <Input placeholder={i18n.t('userName')} />
                </Controller>
              </Form.Item>

              <Form.Item>
                <Controller name={PASSWORD}>
                  <Input placeholder={i18n.t('password')} />
                </Controller>
              </Form.Item>

              <Form.Item>
                <Controller name={ADDROLE}>
                  <SelectBox
                    mode="tags"
                    aria-multiselectable
                    label={i18n.t('addRole')}
                    options={addRolesItem}
                    placeholder={i18n.t('addRole')}
                  />
                </Controller>
              </Form.Item>

              <Form.Item>
                <Controller name={REMOVEROLE}>
                  <SelectBox
                    mode="tags"
                    aria-multiselectable
                    label={i18n.t('removeRole')}
                    options={removeRolesItem}
                    placeholder={i18n.t('removeRole')}
                  />
                </Controller>
              </Form.Item>

              <Form.Item>
                <Controller name={MOBILENUMBER}>
                  <Input placeholder={i18n.t('mobileNumber')} />
                </Controller>
              </Form.Item>

              <Form.Item>
                <Controller name={CATEGORY}>
                  <SelectBox
                    allowClear
                    label={i18n.t('category')}
                    options={categoriesItem}
                    placeholder={i18n.t('category')}
                  />
                </Controller>
              </Form.Item>

              <Form.Item>
                <Controller name={ADMINISTRATOR}>
                  <SelectBox
                    allowClear
                    label={i18n.t('administrator')}
                    options={administratorsItem}
                    placeholder={i18n.t('administrator')}
                  />
                </Controller>
              </Form.Item>

              <Form.Item>
                <Controller name={SUPERVISOR}>
                  <SelectBox
                    allowClear
                    label={i18n.t('supervisor')}
                    options={administratorsItem}
                    placeholder={i18n.t('supervisor')}
                  />
                </Controller>
              </Form.Item>

              <Form.Item>
                <Controller name={HALLMANAGER}>
                  <SelectBox
                    allowClear
                    label={i18n.t('hallManager')}
                    options={administratorsItem}
                    placeholder={i18n.t('hallManager')}
                  />
                </Controller>
              </Form.Item>

              <Form.Item>
                <Controller name={SALEMANAGER}>
                  <SelectBox
                    allowClear
                    label={i18n.t('saleManager')}
                    options={administratorsItem}
                    placeholder={i18n.t('saleManager')}
                  />
                </Controller>
              </Form.Item>

              <Form.Item
                label={status ? i18n.t('active') : i18n.t('deActive')}
              >
                <Controller name={ISACTIVE}>
                  <Switch
                    checked={status}
                    onClick={() => {
                      setStatus(!status);
                    }}
                  />
                </Controller>
              </Form.Item>

              <Form.Item
                wrapperCol={{ ...layout.wrapperCol, offset: 5 }}
              >
                <Button
                  style={{ width: '100px' }}
                  type="primary"
                  isLoading={isPending}
                  htmlType="submit"
                >
                  {i18n.t('update')}
                </Button>
              </Form.Item>
            </Form>
          </FormProvider>
        </Card>
      </LoadingView>
    </>
  );
});
export { EditUser };
